var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.room &&
    (_vm.room.hasRemoteOauth ||
      (_vm.room.deviceType === "iOS" &&
        (_vm.providers.length > 0 || _vm.exchange)))
    ? _c(
        "va-card",
        { staticClass: "fit-height mb-8" },
        [
          _vm.podConfig && _vm.podConfig.requireSync
            ? _c("va-notification", { attrs: { type: "warning" } }, [
                _vm._v(" " + _vm._s(_vm.$t("providers.providersWarning")) + " ")
              ])
            : _vm._e(),
          _vm.microsoftHostMeetingNeedsAuthCall
            ? _c("va-notification", { attrs: { type: "warning" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("providers.microsoftHostMeetingRequiresAuthCall")
                    ) +
                    " "
                )
              ])
            : _vm._e(),
          _c(
            "div",
            [
              _c("div", { staticClass: "va-subtitle" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("roomMeetingSettings.providersTitle")) +
                    " "
                )
              ]),
              _c(
                "v-list",
                { staticClass: "mt-4", attrs: { dense: "" } },
                _vm._l(_vm.providers, function(provider) {
                  return _c(
                    "div",
                    {
                      key: provider.provider,
                      staticClass: "mb-4 border-a border-ra py-2"
                    },
                    [
                      _c(
                        "v-list-item",
                        [
                          provider.logo
                            ? _c(
                                "v-list-item-avatar",
                                { attrs: { size: "32", rounded: "0" } },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: provider.logo,
                                      alt: provider.name
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _c("v-list-item-content", [
                            _c("div", { staticClass: "font-bold text-xl" }, [
                              _vm._v(_vm._s(provider.name))
                            ]),
                            _vm.dontNeedConnection(provider)
                              ? _c("div")
                              : _vm.isEnabled(provider)
                              ? _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("providers.connectedAs")) +
                                      " " +
                                      _vm._s(_vm.connectedAs(provider)) +
                                      " "
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("providers.notconnected"))
                                  )
                                ])
                          ]),
                          _c(
                            "v-list-item-action",
                            [
                              !_vm.dontNeedConnection(provider)
                                ? _c("va-button", {
                                    staticClass: "provider-action-button",
                                    attrs: {
                                      color: _vm.isEnabled(provider)
                                        ? "error"
                                        : "neutral",
                                      size: "l",
                                      disabled:
                                        _vm.dontNeedConnection(provider) ||
                                        (provider.provider ===
                                          "LiveCollaboration" &&
                                          _vm.loading),
                                      cta: _vm.isEnabled(provider)
                                        ? _vm.$t("providers.disconnect")
                                        : _vm.$t("providers.connect")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onToggleActivation(
                                          provider.provider
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      provider.description
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mx-4 mt-2 mb-4",
                              attrs: {
                                title: "More information",
                                type: "info",
                                text: ""
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(provider.description) + " "),
                              provider.requirementsLink
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "font-weight-bold text-decoration-underline",
                                      attrs: {
                                        href: provider.requirementsLink,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "providers.seeRequirementsHere"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "px-4" },
                        [
                          provider.provider == "Zoom"
                            ? _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  _c(
                                    "va-notification",
                                    { attrs: { type: "warning" } },
                                    [
                                      _c("div", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "providers.importantUpdate"
                                              )
                                            )
                                          )
                                        ]),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("providers.zoomWarning")
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._l(_vm.getVisibleFeatures(provider), function(
                            feature
                          ) {
                            return _c(
                              "div",
                              { key: feature },
                              [
                                _vm.isEnabled(provider) ||
                                (feature == "JoinMeeting" &&
                                  provider.provider != "Zoom")
                                  ? _c("va-switch", {
                                      key:
                                        provider.provider +
                                        "-" +
                                        feature +
                                        "-" +
                                        _vm.switchResetKey,
                                      staticClass: "my-1",
                                      class: [
                                        _vm.dependsOnAuthcall(feature, provider)
                                          ? "ml-5"
                                          : ""
                                      ],
                                      attrs: {
                                        text: _vm.getFeatureText(
                                          provider,
                                          feature
                                        ),
                                        disabled: !_vm.hasDependencyMeeted(
                                          feature,
                                          provider
                                        ),
                                        value: _vm.isFeatureEnabled(
                                          feature,
                                          provider
                                        )
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.onFeatureToggle(
                                            feature,
                                            provider.provider,
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                feature === "Calendar" &&
                                provider.provider === "Google" &&
                                _vm.isFeatureEnabled(feature, provider)
                                  ? _c("v-select", {
                                      staticClass: "mt-2",
                                      attrs: {
                                        outlined: "",
                                        attach: "",
                                        items: _vm.googleCalendars,
                                        "item-text": "summary",
                                        "item-value": "id",
                                        label: _vm.$t(
                                          "providers.googleCalendars"
                                        ),
                                        loading: _vm.googleCalendarsLoading,
                                        disabled:
                                          _vm.loading ||
                                          _vm.googleCalendarsLoading,
                                        dense: ""
                                      },
                                      on: {
                                        change: _vm.onSelectGoogleCalendar
                                      },
                                      model: {
                                        value: _vm.selectedGoogleCalendarId,
                                        callback: function($$v) {
                                          _vm.selectedGoogleCalendarId = $$v
                                        },
                                        expression: "selectedGoogleCalendarId"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm.exchange && _vm.room.deviceType !== "AndroidReceiver"
                ? _c(
                    "div",
                    { staticClass: "mb-4 border-a border-ra py-2" },
                    [
                      _c(
                        "v-list-item",
                        [
                          _vm.exchange.logo
                            ? _c(
                                "v-list-item-avatar",
                                { attrs: { size: "32", rounded: "0" } },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.exchange.logo,
                                      alt: _vm.exchange.name
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _c("v-list-item-content", [
                            _c("div", { staticClass: "font-bold text-xl" }, [
                              _vm._v(_vm._s(_vm.exchange.name))
                            ]),
                            _vm.dontNeedConnection(_vm.exchange)
                              ? _c("div")
                              : _vm.isEnabled(_vm.exchange)
                              ? _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("providers.connectedAs")) +
                                      " " +
                                      _vm._s(
                                        _vm.getAccount(_vm.exchange).email
                                      ) +
                                      " "
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("providers.notconnected"))
                                  )
                                ])
                          ]),
                          _c(
                            "v-list-item-action",
                            [
                              !_vm.dontNeedConnection(_vm.exchange)
                                ? _c("va-button", {
                                    staticClass: "provider-action-button",
                                    attrs: {
                                      color: _vm.isEnabled(_vm.exchange)
                                        ? "error"
                                        : "neutral",
                                      size: "l",
                                      disabled: _vm.dontNeedConnection(
                                        _vm.exchange
                                      ),
                                      cta: _vm.isEnabled(_vm.exchange)
                                        ? _vm.$t("providers.disconnect")
                                        : _vm.$t("providers.connect")
                                    },
                                    on: { click: _vm.onExchangeActionClick }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c("va-button", {
                    attrs: {
                      color: "primary",
                      cta: _vm.$t("providers.update"),
                      disabled: _vm.loading || !_vm.room.online
                    },
                    on: { click: _vm.onSendCommand }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("exchange-configuration-dialog", {
            attrs: {
              "initial-config": _vm.exchangeConfig,
              callback: _vm.onExchangeDialogSubmit
            },
            model: {
              value: _vm.exchangeDialogOpen,
              callback: function($$v) {
                _vm.exchangeDialogOpen = $$v
              },
              expression: "exchangeDialogOpen"
            }
          }),
          _c("live-collaboration-configuration-dialog", {
            attrs: {
              "initial-config": _vm.liveCollaborationStoredConfig,
              callback: _vm.onLiveCollaborationDialogSubmit
            },
            model: {
              value: _vm.liveCollaborationDialogOpen,
              callback: function($$v) {
                _vm.liveCollaborationDialogOpen = $$v
              },
              expression: "liveCollaborationDialogOpen"
            }
          }),
          _c("safari-login-dialog", {
            attrs: {
              pendingLoginUrl: _vm.pendingLoginUrl,
              callback: _vm.onPopupFeatureClosed
            },
            model: {
              value: _vm.pendingProvider,
              callback: function($$v) {
                _vm.pendingProvider = $$v
              },
              expression: "pendingProvider"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }